// Source for icons: 
// 1. https://www.freepik.com/search?author=64762985&format=author&iconType=standard&icon_color=solid-black&last_filter=page&last_value=16&page=16&shape=outline&sort=recent&type=icon#uuid=7de9913a-be56-4652-920f-d8725c4eb783
// 2. https://www.freepik.com/search?author=88181740&format=author&iconType=standard&icon_color=solid-black&last_filter=page&last_value=29&page=29&shape=outline&sort=recent&type=icon#uuid=1b334611-1620-4681-89c1-937d9912bc47


//#region Imports
import {
    ActivityLogIcon,
    ArchiveIcon,
    ArrowDownIcon,
    ArrowUpIcon,
    AvatarIcon,
    BorderStyleIcon,
    BookmarkIcon,
    CalendarIcon,
    CaretSortIcon,
    CheckCircledIcon,
    CheckIcon,
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronUpIcon,
    CodeIcon,
    Cross1Icon,
    Cross2Icon,
    CrossCircledIcon,
    CursorArrowIcon,
    DiscordLogoIcon,
    DotFilledIcon,
    DotsHorizontalIcon,
    DotsVerticalIcon,
    DoubleArrowLeftIcon,
    DoubleArrowRightIcon,
    DownloadIcon,
    EnvelopeClosedIcon,
    ExclamationTriangleIcon,
    EyeNoneIcon,
    FileTextIcon,
    GlobeIcon,
    HamburgerMenuIcon,
    LapTimerIcon,
    LaptopIcon,
    Link1Icon,
    Link2Icon,
    ListBulletIcon,
    MagnifyingGlassIcon,
    MixerHorizontalIcon,
    NotionLogoIcon,
    Pencil1Icon,
    Pencil2Icon,
    PlusCircledIcon,
    PlusIcon,
    QuestionMarkCircledIcon,
    ReloadIcon,
    RocketIcon,
    SewingPinIcon,
    ShadowIcon,
    Share2Icon,
    StarIcon,
    StopIcon,
    TextAlignBottomIcon,
    TextAlignMiddleIcon,
    VideoIcon
} from "@radix-ui/react-icons"

import {
    AlertCircleIcon,
    ArrowLeftToLineIcon,
    ArrowRightLeftIcon,
    ArrowRightToLineIcon,
    BuildingIcon,
    CableIcon,
    CameraIcon,
    CheckCheckIcon,
    ChevronsUpDown,
    Clapperboard,
    ClockIcon,
    DatabaseZapIcon,
    ForwardIcon,
    Highlighter,
    InfoIcon,
    LayoutListIcon,
    ListFilterIcon,
    ListPlus,
    ListTodoIcon,
    Loader2,
    MailXIcon,
    MonitorIcon,
    PaperclipIcon,
    PauseCircleIcon,
    PauseIcon,
    RadarIcon,
    RefreshCcwDotIcon,
    RefreshCwIcon,
    RefreshCwOffIcon,
    RewindIcon,
    ScanSearchIcon,
    SendIcon,
    SkullIcon,
    SmileIcon,
    TextSearchIcon,
    ThumbsDown,
    ThumbsUp,
    TrendingDownIcon,
    TrendingUpIcon,
    UserCircle2,
    UserRoundIcon,
    UserRoundPlusIcon,
    XCircle,
    Zap,
} from "lucide-react"

import {AddVideoIcon} from "./add-video";
import {ArrowRightCircleIcon} from "./arrow-right-circle";
import {ArrowUpCircleIcon} from "./arrow-up-circle";
import {BarChartIcon} from "./bar-chart";
import {BellIcon} from "./bell";
import {CertificateIcon} from "./certificate";
import {CircleIcon} from "./circle";
import {ChatIcon} from "./chat";
import {CopyIcon} from "./copy";
import {HamburgerIcon} from "./hamburger";
import {EditIcon} from "./edit";
import {ExitIcon} from "./exit";
import {EqualizerIcon} from "./equalizer";
import {FileCsvIcon} from "./file-csv";
import {FileDocIcon} from "./file-doc";
import {FileTxtIcon} from "./file-txt";
import {FocusIcon} from "./focus";
import {FunctionIcon} from "./function";
import {FunctionPremiumIcon} from "./function-premium";
import {GlobeIconSimple} from "./globe-simple";
import {HighlightHighlighterTipEmptyIcon} from "./higlight-highlighter-tip-empty";
import {HighlightHighlighterTipIcon} from "./highlight-highlighter-tip";
import {InvestigationIcon} from "./investigation";
import {InvoiceIcon} from "./invoice";
import {ListIcon} from "./list";
import {LockIcon} from "./lock";
import {MoonIcon} from "./moon";
import {NoInternetIcon} from "./no-internet";
import {NotificationIcon} from "./notification";
import {QueueIcon} from "./queue";
import {PieChartIcon} from "./pie-chart";
import {PlayIcon} from "./play";
import {PreferencesIcon} from "./preferences";
import {ReadwiseIcon} from "./readwise";
import {ReplayIcon} from "./replay";
import {ScissorIcon} from "./scissor";
import {SettingsIcon} from "./settings";
import {ShareIcon} from "./share";
import {SparklesIcon} from "./sparkles";
import {SparklesPremiumIcon} from "./sparkles-premium";
import {StopCircleIcon} from "./stop-circle";
import {SunIcon} from "./sun";
import {TransferIcon} from "./transfer";
import {TrashIcon} from "./trash";
import {TvIcon} from "./tv";
import {TwitterIcon} from "./twitter";
import {UpgradeIcon} from "./upgrade";
import {UpgradePremiumIcon} from "./upgrade-premium";
import {UploadIcon} from "./upload";
import {WhatsappIcon} from "./whatsapp";
// import {UnlockIcon} from "./unlock";
// import {UserIcon} from "./user";
// import {VideoFileIcon} from "./video-file";

import type {IconName} from '@videohighlight/interfaces/ui'
//#endregion

export const Icons = {
    addVideo: AddVideoIcon,                 //
    account: BuildingIcon,                  // - workspace
    activityLog: ActivityLogIcon,           //
    alertCircle: AlertCircleIcon,           //
    // alerts: RadarIcon,                   //
    alerts: BellIcon,                       //
    // alerts: SearchIcon,                  //
    // alerts: MailSearchIcon,              //
    archive: ArchiveIcon,                   //
    arrowDown: ArrowDownIcon,               //
    arrowRightCircle: ArrowRightCircleIcon, //  Search Bar
    arrowUp: ArrowUpIcon,                   //
    arrowUpCircle: ArrowUpCircleIcon,       //  Search Bar
    attach: PaperclipIcon,                  //
    autoScroll: ChevronsUpDown,             //
    avatarIcon: AvatarIcon,                 //
    bookmark: BookmarkIcon,                 //
    cache: DatabaseZapIcon,                 //
    calendar: CalendarIcon,                 //
    campaigns: SendIcon,                    //
    caretSort: CaretSortIcon,               //
    certificate: CertificateIcon,          //
    // chat: ChatBubbleIcon,                   //
    chat: ChatIcon,                         //  Features - Chat
    check: CheckIcon,                       //
    checkAll: CheckCheckIcon,               //  Select All
    checkCircle: CheckCircledIcon,
    chevronDown: ChevronDownIcon,           //
    chevronLeft: ChevronLeftIcon,           //
    chevronRight: ChevronRightIcon,         //
    chevronUp: ChevronUpIcon,               //  for the sidebar
    circle: CircleIcon,                     //
    circleFilled: DotFilledIcon,            //
    clips: Clapperboard,                   //
    close: Cross1Icon,                      //
    code: CodeIcon,
    collapse: ArrowLeftToLineIcon,          // collapse sidebar
    compressedSummary: DotsVerticalIcon,
    copy: CopyIcon,                         //
    cross: Cross2Icon,                      //
    crossCircle: CrossCircledIcon,          //
    cursorArrow: CursorArrowIcon,           //
    defaultSummary: ListBulletIcon,         //
    discord: DiscordLogoIcon,               //
    dotsHorizontal: DotsHorizontalIcon,     //
    dotsVertical: DotsVerticalIcon,         //
    doubleArrowRight: DoubleArrowRightIcon, //
    doubleArrowLeft: DoubleArrowLeftIcon,   //
    download: DownloadIcon,                 //
    edit: Pencil1Icon,                      //
    email: EnvelopeClosedIcon,              //
    emailSend: SendIcon,                    // Send Invitation
    emailCampaigns: EnvelopeClosedIcon,
    emailCancel: MailXIcon,                 // Cancel Invitation
    embeddings: BorderStyleIcon,            //
    envelope: EnvelopeClosedIcon,           //
    equalizer: EqualizerIcon,               //  Features - Transcript
    error: XCircle,                         //
    errorNonDestructive: XCircle,           // for toasts that have a destructive background color
    exit: ExitIcon,                         //
    expand: ArrowRightToLineIcon,           // expand sidebar
    export: ShareIcon,                      //
    eyeNone: EyeNoneIcon,                   //
    feedback: StarIcon,
    fileCsv: FileCsvIcon,
    fileDoc: FileDocIcon,
    fileTxt: FileTxtIcon,
    filter: ListFilterIcon,                 //
    focus: FocusIcon,                       //
    function: FunctionIcon,                 //
    functionPremium: FunctionPremiumIcon,   // Ai Formatting
    globe: GlobeIconSimple,                 //
    hamburger: HamburgerIcon,               //
    highlightTipEmpty: HighlightHighlighterTipEmptyIcon,
    highlightTip: HighlightHighlighterTipIcon,
    highlight: Highlighter,                 //
    highlightEdit: EditIcon,                // Features - Highlight Edit
    highlightBookmark: Pencil1Icon,         //
    history: ReplayIcon,                    //
    info: InfoIcon,
    insight: BarChartIcon,                  //
    integrationsLink: Link1Icon,
    integrations: TransferIcon,             //
    killProcess: SkullIcon,                 // Kill Processes (Flux Caches)
    keywords: TextSearchIcon,               // AI Alerts - Keywords
    keyPoints: ListIcon,                    // Features - Key Points
    languages: GlobeIcon,                   //
    laptop: LaptopIcon,                     //
    lightAndDarkMode: ShadowIcon,           //
    link: Link2Icon,                        //
    logout: ExitIcon,                       //
    members: UserRoundPlusIcon,             //
    mixerHorizontal: MixerHorizontalIcon,   //
    mobileMenu: HamburgerMenuIcon,          //
    monitor: MonitorIcon,                   // Change Theme (System)
    moon: MoonIcon,                         //
    networkConnectivityError: NoInternetIcon,
    newSummary: ListPlus,                   //
    newTranscript: Highlighter,             //
    needle: SewingPinIcon,
    notification: NotificationIcon,
    notion: NotionLogoIcon,                 //
    pause: PauseIcon,
    pauseCircle: PauseCircleIcon,           // Pause the Link Invitation
    pencil: Pencil1Icon,                    //
    pencilSquare: Pencil2Icon,              //
    newVideo: PlusCircledIcon,              //
    pieChart: PieChartIcon,                 //
    play: PlayIcon,                         // New Video / Play
    // playlist: ListVideoIcon,             //
    playlist: QueueIcon,                    //
    playlistSources: CableIcon,             //
    plus: PlusIcon,                         //
    plusCircle: PlusCircledIcon,            //
    preferences: PreferencesIcon,           //
    profile: UserCircle2,                   //
    qnaAlert: ScanSearchIcon,               //
    radar: RadarIcon,                       //
    readwise: ReadwiseIcon,
    refresh: ReloadIcon,                    //
    rewind: RewindIcon,                     //
    rocket: RocketIcon,
    questions: QuestionMarkCircledIcon,     //
    scissor: ScissorIcon,                   //
    screenShot: CameraIcon,                 //
    scrollLock: TextAlignBottomIcon,        //
    scrollUnlock: TextAlignMiddleIcon,      //
    search: MagnifyingGlassIcon,            //
    settings: SettingsIcon,                 //
    share: Share2Icon,                      //
    shareWithAccount: ForwardIcon,          //
    sharedWithAccount: BuildingIcon,        // (same as account)
    // sharedWithAccount: UserIcon,            //
    notSharedWithAccount: LockIcon,         // Sidebar
    smile: SmileIcon,                       // For Surveys and Feedback toasts
    sparkles: SparklesIcon,                 //
    sparklesPremium: SparklesPremiumIcon,   //
    spinner: Loader2,                       //
    star: StarIcon,
    stop: StopIcon,
    stopCircle: StopCircleIcon,             //  for the chat stop button
    subscriptionFeatures: LayoutListIcon,   //
    subscriptionPlans: ListTodoIcon,        //
    success: CheckCircledIcon,              //
    summary: InvoiceIcon,                   // Features - Summary
    summaryMode: InvoiceIcon,               // Features - Summary
    researchMode: EditIcon,                 // Features - Research Mode
    smartSearch: InvestigationIcon,         // Features - Smart Search
    sun: SunIcon,                           //
    support: QuestionMarkCircledIcon,       //
    switch: ArrowRightLeftIcon,             //  Switch Account
    syncOn: RefreshCwIcon,                  //  For Source Sync Status
    syncOff: RefreshCwOffIcon,              //  For Source Sync Status
    syncOnce: RefreshCcwDotIcon,            //  For Source Sync Status
    terms: FileTextIcon,                    //
    thumbsDown: ThumbsDown,                 //
    thumbsUp: ThumbsUp,                     //
    timer: LapTimerIcon,                    //
    timestamp: ClockIcon,                   //
    transcript: EqualizerIcon,              //
    trash: TrashIcon,
    trendingDown: TrendingDownIcon,         // Bar-Chart
    trendingUp: TrendingUpIcon,             // Bar-Chart
    tv: TvIcon,
    twitter: TwitterIcon,                   //
    updates: SparklesIcon,                  //
    upgrade: UpgradeIcon,
    upgradePremium: UpgradePremiumIcon,     // Rocket but with a color gradient
    upload: UploadIcon,                     //
    usage: BarChartIcon,                    //
    user: UserRoundIcon,                    //
    video: VideoIcon,                       //
    videoFile: UploadIcon,                  //
    warning: ExclamationTriangleIcon,       //
    whatsapp: WhatsappIcon,
    youtube: VideoIcon,
    zap: Zap,
} satisfies Record<IconName, React.ComponentType>